import { FC } from 'react';
import { createInstance } from '@optimizely/react-sdk';
import { WrappedOptimizelyProvider, OptimizelyInstanceProvider, OptimizelyUserProvider } from '@clover-util/optimizely';

import { useMerchant } from 'hooks/context/merchant';
import { useCustomer } from 'hooks/context/customer/customer';
import { isCloverProdEnvironment } from 'util/Environment';
import { getHeapUserId } from 'util/Analytics';

export const optimizely = createInstance({
  sdkKey: isCloverProdEnvironment() ? 'QZPNbyvf46Vj3mo2FFExc' : '2Z6qTQ84cDJqUQ4VakJ8n',
  eventBatchSize: 10,
  eventFlushInterval: 3000
});

export const Optimizely: FC = ({ children }) => {
  const { merchant } = useMerchant();
  const { customer } = useCustomer();

  const { merchantUuid, locale, timezone } = merchant ?? {};
  const { globalCustomerUuid } = customer ?? {};

  return (
    <OptimizelyInstanceProvider client={optimizely}>
      <OptimizelyUserProvider
        id={getHeapUserId() || 'unknown'}
        merchantUuid={merchantUuid}
        merchantLocale={locale}
        merchantTimezone={timezone}
        globalCustomerUuid={globalCustomerUuid}
      >
        <WrappedOptimizelyProvider>
          {children}
        </WrappedOptimizelyProvider>
      </OptimizelyUserProvider>
    </OptimizelyInstanceProvider>
  );
};
